<template>
  <Dropdown :hideArrow="false" ref="dropdown" class="store-select" bclass lclass>
    <template v-slot:button>
      <p class="typo-title1 mr-2">{{ shop.name }}</p>
      <Modal :hideExit="true" @cancel="closeModalShopLogin" v-if="modalAgencyShopLogin">
        <template #header>
          <p class="typo-title1 ">{{ $t("agency.modalLogin.title") }}</p>
        </template>
        <template #default>
          <template>
            <p class="typo-body2 text-grey2">
              {{ $t("agency.modalLogin.youWill") }}
              <span
                class="text-primary"
              >{{ shopConfirm.profile.name }}</span>
            </p>
          </template>
        </template>
        <template #footer>
          <div class="btn-group justify-content-between">
            <button
              class="btn btn-block btn-outline"
              @click="closeModalShopLogin"
            >{{ $t("generals.cancel") }}</button>

            <!-- <template>
            <button
              class="btn btn-block btn-primary ml-2"
              @click="loginShop(shopConfirm)"
            >{{$t("generals.apply")}}</button>
            </template>-->
            <ProcessButton
              class="btn btn-block btn-primary ml-2"
              :status.sync="shopLogStatus"
              @click="loginShop(shopConfirm)"
              default="btn-primary"
            >
              {{ $t("generals.apply") }}
              <!-- <template #loading>Apply</template>
            <template #success>Apply</template>
            <template #error>Apply</template>
              <template #default>Apply</template>-->
            </ProcessButton>
          </div>
        </template>
      </Modal>
    </template>
    <div class="search">
      <i class="icon icon-search"></i>

      <input
        v-focus
        ref="search"
        type="text"
        :placeholder="$t('agency.searchPlaceholder')"
        v-model="searchVal"
      />

      <i v-if="searchVal != ''" @click.stop="clearSearch" class="icon icon-cancel"></i>
    </div>
    <template v-if="stores && stores.length > 0">
      <div class="shop-list" v-if="querriedList.length > 0">
        <div
          class="gp_dropdown-item"
          @click="showLoginShop(item)"
          v-for="(item, index) in querriedList"
          :key="item.shopifyDomain + '_' + index"
        >
          <p class="typo-title1 mb-half">{{ item.profile.name }}</p>
          <p class="typo-small text-grey2 mb-half">{{ item.shopify_domain }}</p>
          <hr class="bg-grey4 mt-1" />
        </div>
      </div>
      <div class="shop-list search-empty" v-else>
        <div class="gp_dropdown-item disable">
          <img :src="publicPath + require('@/core/assets/EmptyPages/search.svg')" />
          <p class="typo-title1 mb-half">{{ $t("agency.noShop") }}</p>
          <!-- <p class="typo-small">{{$t("agency.searchShopEmptyDesc")}}</p> -->
        </div>
      </div>
    </template>

    <template v-else>
      <div class="shop-list empty-list">
        <div class="gp_dropdown-item disable">
          <p class="typo-title1 mb-half">{{ $t("agency.noReference") }}</p>
          <p class="typo-small">{{ $t("agency.noReference") }}</p>
        </div>
      </div>
    </template>
    <template v-slot:ConfirmLogin></template>
  </Dropdown>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { ProcessButton } from "@/core/shared";
export default {
  name: "StoreSelect",
  components: {
    ProcessButton
  },
  props: {
    shop: Object,
    stores: Array
  },
  data() {
    return {
      searchVal: "",
      modalAgencyShopLogin: false,
      shopConfirm: Object
    };
  },
  computed: {
    ...mapState("agency", {
      shopLogStatus: state => state.shopLogStatus
    }),
    allStore() {
      if (!this.stores || !this.stores.length) {
        return [];
      }
      return this.stores.filter(item => {
        if (this.shop.shopifyDomain == item.shopify_domain) return false;
        return true;
      });
    },
    querriedList() {
      if (!this.allStore || !this.allStore.length) {
        return [];
      }
      let q = this.searchVal.toLowerCase();
      return this.allStore.filter(item => {
        let name = `${item.profile.name}`;
        if (
          name.toLowerCase().indexOf(q) > -1 ||
          item.shopify_domain.toLowerCase().indexOf(q) > -1
        )
          return true;
        return false;
      });
    }
  },
  created() {
    // let { shop, stores } = this;
  },
  methods: {
    // itemFilterClick(item) {
    //   if (this.$refs.dropdown) {
    //     this.$refs.dropdown.toggleDropdown();
    //   }
    //   if (fn) fn();
    // },
    showLoginShop(item) {
      this.closeDropdown();
      this.modalAgencyShopLogin = true;
      this.shopConfirm = item;
    },
    closeDropdown() {
      const $dropdown = this.$refs && this.$refs.dropdown;
      if ($dropdown && $dropdown.closeDropdown) $dropdown.closeDropdown();
    },
    sortFunc(sort) {
      this.currentFilter = sort.text;
      this.$emit("onClickFilter", sort.key);
    },
    clearSearch() {
      this.searchVal = "";
      this.$refs && this.$refs.search && this.$refs.search.focus();
    },
    closeModalShopLogin() {
      this.modalAgencyShopLogin = false;
    },
    ...mapActions("agency", {
      loginShop: "loginShop"
    })
  }
};
</script>

<style lang="scss" scoped>
.store-select::v-deep {
  .shop-list {
    max-height: 450px;
    overflow: auto;
  }
  .dropdown_toggle {
    padding: 4px 0;
    background: transparent;
    &:hover {
      color: $cPrimary;
    }
  }
  .gp_dropdown_list {
    min-width: 330px;
    left: 0;
    box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.2);
  }
  .gp_dropdown-item {
    padding: 6px 16px;
    &:first-child {
      margin-top: 0;
      padding-top: 12px;
    }
    &:last-child {
      margin-bottom: 0;
      padding-bottom: 12px;
      hr {
        display: none;
      }
    }
    &.disable {
      opacity: 1;
      align-items: center;
      display: flex;
      flex-direction: column;
      img {
        width: 50%;
      }
    }
  }
  .search {
    position: relative;
    display: flex;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    i.icon {
      position: absolute;
      font-size: 16px;
      align-self: center;
    }
    .icon-search {
      left: 14px;
    }
    .icon-cancel {
      right: 4px;
      padding: 8px;
      &:hover {
        color: $cPrimary;
        cursor: pointer;
      }
    }
    input {
      padding: 17.5px 38px 17.5px 48px;
      width: 100%;
      border-width: 0 0 1px 0;
      border-radius: 0;
      border-color: $grey3;
    }
  }
}
</style>
